import _ from 'underscore';

import {Sequence} from 'components/Sequence';
import {PolymerTabState} from 'molbio/tabstates/PolymerTabState';
import {TabStateDefaults} from 'Navigation';

class TranslationTableTabState extends PolymerTabState<Sequence> {
  override defaults(): TabStateDefaults {
    return _(super.defaults()).extend({
      title: 'Translations',
    });
  }

  deleteTranslations(translationIds: Array<number>): JQueryPromise<{message: string; deleted: number}> {
    const translations = this.sequence()._sequence().translations();
    const translationsToDelete = translations.filter((t) => Array.from(translationIds).includes(t.id));
    const xhr = translations.bulkDelete(translationsToDelete, {fileUpdate: true});
    xhr.done(() => this.sequence().updateVersions());
    return xhr;
  }
}

export default TranslationTableTabState;
